<div class="page-header">
  <div class="page-header-title">{{ title() | translate }}</div>
  <div class="page-header-breadcrumbs">
    <mat-icon [svgIcon]="icon()" class="page-header-breadcrumbs-icon"></mat-icon>
    @for (segment of breadcrumbs; track $index) {
      <a class="page-header-breadcrumbs-link" routerLink="{{ getBreadcrumbRoute($index) }}">{{ segment.translationKey | translate }}</a>
      @if ($index < breadcrumbs.length - 1) {
        <mat-icon class="page-header-breadcrumbs-chevron">chevron_right</mat-icon>
      }
    }
  </div>
</div>
